import React, { useCallback, useState } from 'react';
import Container from '../components/common/Container';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { handleNextPage, handlePrevPage, setSelectedIndex } from '../redux/legalPersonSlice';
import { useTranslation } from 'react-i18next';
import InputSearchBox from '../components/common/InputSearchBox';
import DateSearchBox from '../components/common/DateSearchBox';
import Button from '../components/common/Button';
import RegisteredLegalPersonDetailModal from '../components/modal/RegisteredLegalPersonDetailModal';

const RegisteredLegalPerson: React.FC = () => {
    const legalPersonInfo = useSelector((state: RootState) => state.legalPerson);
    const dispatch = useDispatch();

    const { t } = useTranslation('verification');

    const [ corporateNumber, setCorporateNumber] = useState<string>('');
    const [ startDate, setStartDate ] = useState<string>('');
    const [ endDate, setEndDate ] = useState<string>('');
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const handleCloseDetailModal = useCallback(() => setIsDetailModalOpen(false), []);
    const onHandlePrevPage = useCallback(() => dispatch(handlePrevPage()), []);
    const onHandleNextPage = useCallback(() => dispatch(handleNextPage()), []);

    return (
        <Container label={t('registered legal person history')}>
            <RegisteredLegalPersonDetailModal
                isOpen={isDetailModalOpen}
                onClose={handleCloseDetailModal}
            />
            <div className="search-form">
                <InputSearchBox
                    inputValue={corporateNumber}
                    placeholder={t('search by company name or company number')}
                    onChange={setCorporateNumber}
                />
                <DateSearchBox
                    label={t('start date')}
                    inputValue={startDate}
                    onChange={setStartDate}
                />
                <DateSearchBox
                    label={t('end date')}
                    inputValue={endDate}
                    onChange={setEndDate}
                />
                <div className="ml-20 inline-block">
                    <Button
                        label={t('search')}
                        onClick={() => {
                            console.log('search button is clicked');
                        }}
                    />
                </div>
                <div className="pl-20 inline-block cursor-pointer"
                    onClick={() => {
                        console.log('Resetting search criteria');
                        setCorporateNumber('');
                        setStartDate('');
                        setEndDate('');
                        window.location.reload();
                    }}>
                    <span className="underline">{t('reset')}</span>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>{t('name')}</th>
                        <th>{t('corporate number')}</th>
                        <th>{t('reference datetime')}</th>
                        <th>{t('reference person')}</th>
                        <th>{t('status')}</th>
                        <th>{t('action')}</th>
                    </tr>
                </thead>
                {legalPersonInfo.data.map((value, index) => {
                    return (
                        <tr
                            key={index}
                            onClick={() => {
                                dispatch(setSelectedIndex(index));
                                setIsDetailModalOpen(true);
                            }}
                        >
                            {/* <td>{value.name}</td>
                            <td>{value.corporate_number}</td>
                            <td>{value.received_date}</td>
                            <td>{value.reference_person_department + "・" + value.reference_person_name}</td>
                            <td className="complete">{t(value.status) + "(" + t(value.verification_type) + ")"}</td> */}
                            <td>
                                <Button
                                    label={t('details')}
                                    onClick={() => {
                                        console.log('clicked');
                                    }}
                                />
                            </td>
                        </tr>
                    )
                })}
            </table>
            <div className="pagination">
                <Button
                    label={t('prev page')}
                    onClick={onHandlePrevPage}
                    addedClass='mx-[10px]'
                />
                <span>{legalPersonInfo.selectedPage}</span>
                &nbsp;/&nbsp;
                <span>{legalPersonInfo.totalPage}</span>
                <Button
                    label={t('next page')}
                    onClick={onHandleNextPage}
                    addedClass='mx-[10px]'
                />
            </div>
        </Container>
    );
};

export default RegisteredLegalPerson;
